(function () {
  if (document.documentElement.dataset.country !== 'BE') return;

  var SELECTORS = [
    '#alma-widget button',
    '#alma-widget-modal-main-container button'
  ];

  function is4xButton(button) {
    var label = button.getAttribute('aria-label') || '';
    var text = button.textContent.trim();
    return /4\s*x/i.test(label) || text === '4x';
  }

  function hide4xButton(button) {
    if (!button || button.dataset.jscAlma4xHidden === '1') return;
    button.hidden = true;
    button.style.display = 'none';
    button.setAttribute('aria-hidden', 'true');
    button.tabIndex = -1;
    button.dataset.jscAlma4xHidden = '1';
  }

  function hideAlma4x() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (button) {
        if (is4xButton(button)) hide4xButton(button);
      });
    });
  }

  var debounceTimer;
  function scheduleHide() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(hideAlma4x, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideAlma4x);
  } else {
    hideAlma4x();
  }

  // Only observe Alma widget containers, not entire body
  var observeTarget = document.querySelector('#alma-widget, #alma-widget-modal-main-container');
  if (observeTarget) {
    var observer = new MutationObserver(scheduleHide);
    observer.observe(observeTarget, { childList: true, subtree: true });
  } else {
    // Fallback: watch body but disconnect after first successful hide
    var bodyObserver = new MutationObserver(function() {
      hideAlma4x();
      var target = document.querySelector('#alma-widget, #alma-widget-modal-main-container');
      if (target) bodyObserver.disconnect();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();